export default __webpack_public_path__ + "static/media/android.785c5d0d.svg";